<template>
  <div class="no-user-content" v-if="!userInfo">
    <!-- <div class="top-text">
      <span class="text">
        登录
      </span>
    </div> -->
    <div class="login-content">
      <div style="display: block;align-items: center;justify-content: center;margin-top: 84px;">
        <div class="name">开启智慧教学之旅</div>
        <div class="avatar">
          <img :src="require('@/assets/images/home/Booklist.png')" alt="" />
        </div>
        <div class="login-button" @click="zhsLogin">
          <span style="margin-right: 10px">账号登录</span>
          <i class="iconfont icon-chakanquanbu"></i>
        </div>
      </div>
    </div>
  </div>
  <div v-if="userInfo">
    <el-dropdown trigger="hover" :append-to-body="false" :show-arrow="false" v-if="zhsRole == 1 || zhsRole == 2">
      <span class="toggle-tip">
        <span> 切换</span>
        <img src="~@/assets/images/qiehuan.png" class="iconfont icon-qiehuan" alt="">
      </span>
      <template #dropdown>
        <el-dropdown-menu class="role-dropdown">
          <el-dropdown-item v-for="(item, index) in roleList" :key="item.name" @click="toggleZhsRole(item, index)">
            {{ item.name }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
    <div class="user-class">
      <!-- 学生 -->
      <div class="user-content" v-if="currentRole == 3 || currentRole == 0">
        <div class="top-text">
          <!-- <el-icon style="color: #758af6;margin-right: 5px;font-size: 24px;"><CaretRight /></el-icon> -->
          <span class="user-name">{{ userInfo.realname }}同学，您好！</span>
          <img src="~@/assets/images/common/bioashi-iocn.png" class="icon" alt="">
        </div>
        <RoleCard :menuList="appList" :zhsRole="currentRole" :onlineLink="onlineLink.student" />
      </div>
      <!-- 教师 -->
      <div class="user-content" v-if="currentRole == 2">
        <div class="top-text">
          <!-- <el-icon style="color: #758af6;margin-right: 5px;font-size: 24px;"><CaretRight /></el-icon> -->
          <span class="user-name">{{ userInfo.realname }}老师，您好！</span>
          <img src="~@/assets/images/common/bioashi-iocn.png" class="icon" alt="">
        </div>
        <RoleCard :menuList="appList" :zhsRole="currentRole" :onlineLink="onlineLink.teacher" />
      </div>
      <!-- 管理员 -->
      <div class="user-content" v-if="currentRole == 1">
        <div class="top-text">
          <!-- <el-icon style="color: #758af6;margin-right: 5px;font-size: 24px;"><CaretRight /></el-icon> -->
          <span class="user-name">{{ userInfo.realname }}管理员，您好！</span>
          <img src="~@/assets/images/common/bioashi-iocn.png" class="icon" alt="">
        </div>
        <RoleCard :menuList="appList" :zhsRole="currentRole" :onlineLink="onlineLink.manage" />
      </div>
    </div>

  </div>
</template>

<script>
import RoleCard from './RoleCard.vue'
import { handleLogin } from '@/plugins/utils'
export default {
  components: {
    RoleCard
  },
  props: {
    userInfo: {
      type: Object,
      default: null
    },
    zhsRole: {
      type: Number || String,
      default: 0
    }
  },
  watch: {
    zhsRole: {
      handler(value) {
        this.getAppList(value)
        let result = []
        console.log(value, 'vvvv');
        if (value == 1) {
          result = [
            { name: '管理员', role: 1 },
            { name: '教师', role: 2 },
            { name: '学生', role: 3 }
          ]
        } else if (value == 2) {
          result = [
            { name: '教师', role: 2 },
            { name: '学生', role: 3 }
          ]
        }
        this.roleList = result
        this.currentRole = value
      },
      immediate: true
    }
  },
  data() {
    return {
      roleList: [],
      currentRole: 2,
      // 学堂链接
      onlineLink: {
        manage: 'https://onlineweb.zhihuishu.com/onlineMuster/managerIndex',
        teacher: 'https://onlineweb.zhihuishu.com/onlineMuster/teacherIndex',
        student: 'https://onlineweb.zhihuishu.com/onlinestuh5'
      },
      appList: [],
      manageMenu: [
        {
          name: '教学指挥中心',
          link: 'https://hike-course-homepage.zhihuishu.com/managerCenter/home?sid=1204',
          img: require('@/assets/images/home/教学指挥中心.png')
        },
        {
          name: '数据大屏',
          link: 'https://dch5.zhihuishu.com/dailyData.html#/dailyData1/4Yda9gdv?sid=1204',
          img: require('@/assets/images/home/数据大屏.png')
        },
        {
          name: '数据中心',
          link: 'https://dch5.zhihuishu.com/newDataCenter.html#/dataOverview?sid=1204',
          img: require('@/assets/images/home/数据中心.png')
        },
        {
          name: '教学日报',
          link: 'https://dch5.zhihuishu.com/dailyData.html#/dailyData/4Yda9gdv',
          img: require('@/assets/images/home/教学日报.png')
        },
        {
          name: '教研中心',
          link: '/teachCenter.html',
          img: require('@/assets/images/home/教研中心.png')
        },
        {
          name: '评审平台',
          link: 'https://cdtupms.zhihuishu.com',
          img: require('@/assets/images/home/金课评审.png')
        },
        {
          name: '后台管理',
          link: 'https://cdtu.zhihuishu.com/admin/#/dashboard/index',
          img: require('@/assets/images/home/评审平台.png')
        },
        {
          name: '帮助中心',
          link: 'https://hike-course-homepage.zhihuishu.com/helpCenter',
          img: require('@/assets/images/home/帮助中心1.png')
        }
      ],
      teacherMenu: [
        {
          name: '教研中心',
          link: '/teachCenter.html',
          img: require('@/assets/images/home/教研中心.png')
        },
        {
          name: '题库',
          link: 'https://questionbankh5.zhihuishu.com/questionList/1/1?tab=1&source=1',
          img: require('@/assets/images/home/题库.png')
        },
        {
          name: '资源库',
          link: 'https://hikeweb.zhihuishu.com/RSRCcenter/resourceCenter/resourceCenter/cloudLibrary',
          img: require('@/assets/images/home/资源库.png')
        },
        {
          name: 'AI资源库',
          link: 'https://hikeweb.zhihuishu.com/hike-tch/resource?type=2',
          img: require('@/assets/images/home/AI资源库.png')
        },
        {
          name: '金课评审',
          link: 'https://hike-course-homepage.zhihuishu.com/goldenCourse',
          img: require('@/assets/images/home/金课评审.png')
        },
        {
          name: '群文件管理',
          link: 'https://ct.zhihuishu.com/classroomTools/gpFile/home',
          img: require('@/assets/images/home/群文件管理1.png')
        },
        {
          name: '评审平台',
          link: 'https://cdtupms.zhihuishu.com',
          img: require('@/assets/images/home/评审平台.png')
        },
        {
          name: '帮助中心',
          link: 'https://hike-course-homepage.zhihuishu.com/helpCenter',
          img: require('@/assets/images/home/帮助中心1.png')
        }
      ],
      studentMenu: [
        {
          name: '消息通知',
          link: 'https://onlineh5.zhihuishu.com/onlineWeb.html#/student/noticeCenter?entry=1&noticeType=0',
          img: require('@/assets/images/home/帮助中心.png')
        },
        {
          name: '群文件管理',
          link: 'https://ct.zhihuishu.com/classroomTools/gpFile/home',
          img: require('@/assets/images/home/群文件管理.png')
        },
        {
          name: '帮助中心',
          link: 'https://hike-course-homepage.zhihuishu.com/helpCenter',
          img: require('@/assets/images/home/帮助中心.png')
        }
      ]
    }
  },
  methods: {
    toggleZhsRole(data) {
      this.currentRole = data.role
      this.getAppList(data.role)
    },
    zhsLogin() {
      handleLogin(this.$schoolId)
      // const host = window.location.protocol + '//' + window.location.host
      // // const loginUrl = host + '/index.html'
      // const url = host + '/index.html'
      // window.location.href = `${host}/hike-boot/AuthSys/getAuthorize?redirectUri=${url}&failRedirectUri=${url}&source=${this.$schoolId}`
    },
    async getAppList(e) {
      const params = {
        role_type: e
      }
      const data = await this.$http.getAppList(params)
      this.appList = data.filter(item => item.app_name != 'zhs_dz_platform')
      const onlineUrl = data.find(item => item.app_name == 'zhs_dz_platform').jump_url
      if (e == 1) {
        this.onlineLink.manage = onlineUrl
      } else if (e == 2) {
        this.onlineLink.teacher = onlineUrl
      } else if (e == 3) {
        this.onlineLink.student = onlineUrl
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.no-user-content {

  // background-image: url('~@/assets/images/index.png');
  // background-size: cover;
  // background-repeat: no-repeat;
  // background-size: 100% 100%;
  // transform: translateY(-82px);
  height: 445px;
  width: 100%;
  // height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  // background: #fff;
  .name {
    text-align: center;
    font-size: 20px;
    color: #222;
    line-height: 28px;
  }

  .login-content {

    background-color: #F7F8Fa;
    border: 0.5px solid #E5E6EB;
    height: 350px;
    // background-image: url('~@/assets/images/index.png');
    // background-size: cover;
    // margin-bottom: 93px;
    // padding: 100px 30px 30px 30px;
    width: 100%;
    padding: 12px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .avatar {
      margin-top: 45px;
      height: 100px;

      img {
        height: 100%;
      }
    }
  }

  .login-button {
    margin-top: 50px;
    width: 220px;
    height: 56px;
    border-radius: 28px;
    line-height: 56px;
    text-align: center;
    background: $--color-primary;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    margin-bottom: 52px;
  }
}

.top-text {
  position: absolute;
  top: 16%;
  left: 71%;

  font-size: 20px;
  line-height: 35px;
  color: #2a2a2a;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 18px;
  color: #1D2129;
  line-height: 26px;

  .english-menu {
    font-size: 12px;
    color: #ababab;
  }

  .user-name {
    color: #2a2a2a;
    font-family: PingFangSC-Medium;
    font-weight: 500;
  }

  .icon {
    height: 14px;
    width: 14px;
  }
}

.user-class {
  height: 445px;
  width: 100%;
}

.user-content {
  background-color: #F7F8Fa;
  border: 0.5px solid #E5E6EB;
  height: 350px;
  border-radius: 16px;
}

.user-content {
  // transform: translateY(-82px);

  .toggle-role {
    position: absolute;
    top: 32px;
    right: 26px;
    display: flex;
    align-items: center;
    color: #7d7d7d;
    font-size: 12px;
    cursor: pointer;

    &:hover {
      color: $--color-primary;
    }
  }

  .center-box {
    display: flex;
    justify-content: space-between;
    width: 294px;
    height: 64px;
    margin-bottom: 10px;
    line-height: 64px;
    padding: 0 16px;
    color: #fff;
    font-size: 16px;

    .enter-arrow {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #fff;
      cursor: pointer;
    }
  }

  .resource-center {
    background: url(~@/assets/images/home/resource_center.png);
  }

  .manage-center {
    background: url(~@/assets/images/home/teacher_manage.png);
  }

  .cloud-class {
    background: url(~@/assets/images/home/cloudClass.png);
  }

  .cloud-course {
    background: url(~@/assets/images/home/cloudBeike.png);
  }

  .about-msg {
    list-style: none;
    display: flex;
    justify-content: space-between;
    // height: 96px;
    width: 294px;

    .link-item {
      width: 93px;
      height: 96px;
      padding: 24px 14px;
      background: #fff;

      &:nth-last-child {
        margin-right: 0;
      }

      .item-img {
        list-style: none;
        color: $--color-primary;
        text-align: center;

        .iconfont {
          font-size: 14px;
          height: 14px;
          width: 14px;
        }
      }

      .link-name {
        margin-top: 14px;
        text-align: center;
        color: #191d26;
        font-size: 12px;
      }
    }
  }
}

// .user-avatar {
//   width: 84px;
//   height: 84px;
//   border-radius: 50%;
//   border: 1px solid #fff;
//   img {
//     width: 100%;
//     height: 100%;
//     border-radius: 50%;
//   }
// }
.name {
  margin-top: 14px;
  height: 28px;
  font-size: 20px;
  color: #222;
}

.user-role {
  margin-top: 8px;
  margin-bottom: 8px;
  height: 26px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: $--color-primary;
  line-height: 26px;
}

.toggle-tip {
  font-weight: 400;
  font-size: 14px;
  color: #1D2129;
  /* line-height: 22px; */
  cursor: pointer;
  align-items: center;
  display: flex;
  justify-content: center;

  .icon-qiehuan {
    align-items: center;
    margin-left: 8px;
    font-size: 14px;
    height: 14px;
    width: 14px;
  }
}

::v-deep {
  .el-dropdown {
    position: absolute;
    top: 16%;
    right: 8%;
    z-index: 2;
    font-weight: 400;
    font-size: 14px;
    color: #1D2129;
  }

  .el-dropdown-menu__item {
    line-height: 20px;
    padding: 3px 10px;
    font-size: 12px;
    color: #7d7d7d;
  }
}

:deep(.el-scrollbar__wrap) {
  width: 60px;
  height: auto;
}

:deep(.el-dropdown):hover {
  color: $--color-primary;
}

:deep(.el-dropdown-menu) {
  width: 60px;
}

:deep(.el-dropdown-menu__item:not(.is-disabled):hover, .el-dropdown-menu__item:focus) {
  color: $--color-primary;
  background: $--hover-background-color;
}

.role-dropdown {
  width: 70px;
}
</style>
